/* eslint-disable max-len */
// Dependencies
import React, {useState} from 'react'
import {connect} from 'react-redux'

// Images

// Styles
import '@lazarusai/forms-ui-components/dist/index.css'
import stylesStepFeed from '../styles/StepFeed.module.css'
import Helpers from '../Helpers'
import {Icon, Animation} from '@lazarusai/forms-ui-components'

// Components

function StepFeed({
  backgroundColor='#000',
  ...props
}) {
  const [activeStep, setActiveStep] = useState(0)

  function getSourceBreakdown(sources) {
    const sourceBreakdown = {}
    for (let sIndex = 0; sIndex < sources.length; sIndex++) {
      const source = sources[sIndex]
      const type = Helpers.fileTypeFormatFromName(source)
      if (sourceBreakdown?.[type]) {
        sourceBreakdown[type].push(source)
      } else {
        sourceBreakdown[type] = [source]
      }
    }
    return sourceBreakdown
  }

  function onClickStep(sIndex) {
    setActiveStep(sIndex)
    props.onClickStep(sIndex)
  }

  return (
    <div
      className={stylesStepFeed['step-feed']}
    >
      <div
        className={stylesStepFeed['step-feed-top-text-wrapper']}
        style={{
          boxShadow: `0 0 8px 8px ${backgroundColor}`,
          backgroundColor: backgroundColor,
        }}
      >
        <div className={stylesStepFeed['step-feed-top-text']}>
          {props.topText}
        </div>
      </div>
      {props.steps?.map((step, sIndex) => {
        const stepLoading = step?.isLoading
        const stepError = step?.isError
        const stepTitle = step?.title || `Step ${sIndex + 1}`
        const stepSourceFiles = step?.sources || []
        const stepSourceBreakdown = getSourceBreakdown(stepSourceFiles)
        const stepDescription = step?.description
        return (
          <div
            className={`${stylesStepFeed['step-row']} ${(activeStep === sIndex) ? stylesStepFeed['step-row-active'] : ''}`}
            key={`Step-${sIndex}`}
            onClick={() => {
              onClickStep(sIndex)
            }}
          >
            <div
              className={stylesStepFeed['step-row-status']}
            >
              <div className={stylesStepFeed['step-row-status-active']}>
              </div>
            </div>
            <div
              className={`${stylesStepFeed['status-poll']} ${stepError ? stylesStepFeed['status-poll-error'] : stepLoading ? '':stylesStepFeed['status-poll-active']}`}
            >
              <div
                className={stylesStepFeed['status-icon']}
              >
                {stepError ?
                <Icon
                  icon={'close-outline'}
                /> :
                stepLoading ?
                <Animation
                  animationState={'generating'}
                  stopAnimation={false}
                  height={'24px'}
                  width={'24px'}
                /> :
                <Icon
                  icon={'checkmark'}
                />
                }
              </div>
              {stepTitle !== 'Conclusion' &&
              <div
                className={stylesStepFeed['poll']}
              />
              }
            </div>
            <div
              className={stylesStepFeed['step-info']}
            >
              <div
                className={stylesStepFeed['step-info-step-index']}
              >
                {`Step ${sIndex + 1}`}
              </div>
              <div
                className={stylesStepFeed['step-info-title']}
              >
                {stepTitle}
              </div>
              <div
                className={stylesStepFeed['step-sources']}
              >
                {Object.keys(stepSourceBreakdown)
                    .map((sourceType) => {
                      const icon = sourceType === 'Image' ?
                        'image-outline':
                        sourceType === 'Folder'?
                        'folder-outline':
                        sourceType === 'Audio'?
                        'volume-up-outline':
                        sourceType === 'Video'?
                        'video-outline': 'file-outline'
                      return (
                        <div
                          key={`${sIndex}-${sourceType}`}
                          className={stylesStepFeed['source-type']}
                        >
                          <Icon
                            icon={icon}
                          />
                          {`${stepSourceBreakdown[sourceType].length}`}
                        </div>
                      )
                    })
                }
              </div>
              <div
                className={stylesStepFeed['step-description']}
              >
                {stepDescription}
              </div>
            </div>
          </div>
        )
      })}
    </div>
  )
}

const mapStateToProps = (state, ownProps) => ({
  theme: state.userReducer.theme,
  cookies: ownProps.cookies,
  storage: state.firebaseReducer.storage,
  database: state.firebaseReducer.database,
  firestore: state.firebaseReducer.firestore,
  userMessage: state.userReducer.userMessage,
  notificationType: state.userReducer.notificationType,
  notificationIcon: state.userReducer.notificationIcon,
  lang: state.userReducer.lang,
  isSignedIn: state.userReducer.isSignedIn,
  isFirebaseSignedIn: state.userReducer.isFirebaseSignedIn,
  isMFANeeded: state.userReducer.isMFANeeded,
  mfaError: state.userReducer.mfaError,
  user: state.userReducer.user,
})

export default connect(
    mapStateToProps,
    {},
)(StepFeed)
